import { Injectable } from '@angular/core';
import { ApiService } from '../../core/api.service';
import { Observable } from 'rxjs';
import { BlogPost, BlogPostCreateDto, BlogPostUpdateDto } from './blog.model';

@Injectable({ providedIn: 'root' })
export class BlogService {
  constructor(private api: ApiService) {}

  // Criar artigo
  createPost(post: BlogPostCreateDto): Observable<any> {
    return this.api.post('/blog', post);
  }

  // Atualizar artigo
  updatePost(id: string, post: BlogPostUpdateDto): Observable<any> {
    return this.api.put(`/blog/${id}`, post);
  }

  // Deletar artigo
  deletePost(id: string): Observable<any> {
    return this.api.delete(`/blog/${id}`);
  }

  // Listar artigos
  getPosts(page: number = 1, pageSize: number = 20, category?: string): Observable<{ data: BlogPost[]; meta: any }> {
    const params: any = { page, pageSize };
    if (category) params.category = category;
    return this.api.get('/blog', params) as Observable<any>;
  }

  // Buscar artigo por slug
  getPostBySlug(slug: string): Observable<BlogPost> {
    return this.api.get(`/blog/${slug}`) as Observable<any>;
  }

  // Buscar artigo por ID
  getPostById(id: string): Observable<BlogPost> {
    return this.api.get(`/blog/${id}`) as Observable<any>;
  }

  // Gerar slug a partir do título
  generateSlug(title: string): string {
    return title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove acentos
      .replace(/[^\w\s-]/g, '') // Remove caracteres especiais
      .replace(/\s+/g, '-') // Substitui espaços por hífen
      .replace(/-+/g, '-') // Remove hífens duplicados
      .replace(/^-|-$/g, '') // Remove hífens no início/fim
      .trim();
  }
}
